// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2M8oo","footer":"Form_footer__2iVbh"};